import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  root: {
    overflowY: "auto",
  },
  dataGridTable: {
    "& .MuiDataGrid-columnHeaders": {
      background: "#1D426D33",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 400,
      textTransform: "uppercase",
      fontSize: 12,
    },
    "& .MuiDataGrid-iconSeparator ": {
      color: "#000 !important",
    },
    "& .MuiDataGrid-virtualScroller": {
      scrollbarWidth: "thin",
      "&::-webkit-scrollbar": {
        height: 8,
      },
    },
  },
  iconsWrapper: {
    display: "flex",
    gap: 8,
  },
  addBtn: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "10px 20px",
  },
  funBtn: {
    display: "flex",
    justifyContent: "center",
    padding: "10px 4px",
  },
}));

export default useStyles;
